import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import Uri from "jsuri";

import {
  MetricTable,
  sortNumeric,
  selectFormat,
  TableContentCell,
  Error,
} from "./../../Utils/Utils.js";

const metric = (value) => (cell, row, rowIndex, params) => {
  const props = { ...cell, ...params, format: cell.value < 10 ? "0.0" : null };
  return (
    <div>
      <MetricTable {...props} />
      <span>({selectFormat("number", row[value], "0,0")})</span>
    </div>
  );
};

class FacebookTop5PostsPer1000 extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable(data) {
    const { cells, title, url } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const isVideoWidget = title.includes("Videos");
    const columnLabel = isVideoWidget ? "Views" : "Impressions";
    const defaultSortType = isVideoWidget ? "views" : "engagements";

    const columns = [
      {
        dataField: "title",
        text: "Title",
        style: { width: "320px", minWidth: "320px", textAlign: "left" },
        headerAlign: "left",
        formatter: TableContentCell,
        formatExtraData: {
          name: new Uri(url).hasQueryParam("p")
            ? new Uri(url).getQueryParamValue("p")
            : url.split("/")[2],
        },
        csvFormatter: (cell, row) => row && (row.title || row.tweet_text || ""),
        sort: true,
      },
      {
        dataField: "views",
        text: columnLabel,
        headerFormatter: (col, colIndex, { sortElement }) => (
          <div>
            {columnLabel} per 1k
            <br /> <span>(Total {columnLabel})</span> {sortElement}
          </div>
        ),
        style: { width: "140px", minWidth: "140px" },
        formatter: metric("total_views"),
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "engagements",
        text: "Engagements per 1k",
        headerFormatter: (col, colIndex, { sortElement }) => (
          <div>
            Engagements per 1k <br /> <span>(Total Engagements)</span>{" "}
            {sortElement}
          </div>
        ),
        style: { width: "140px", minWidth: "140px" },
        formatter: metric("total_engagements"),
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const defaultSorted = [
      {
        dataField: defaultSortType,
        order: "desc",
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data);
  }
}

export default FacebookTop5PostsPer1000;
